/* 
  START: you can define custom functions within this area
  v v v v v v v v v v v v v v v v v v v v v v v v v v v
*/


function bindCookiePrefsClick() {
    var cookielink = document.querySelector('a[href="#CookiePreferences"]');
    if (cookielink) {
        cookielink.addEventListener('click', openCookiePrefs, false);
    }
}
function openCookiePrefs(e) {
    e.preventDefault();
    if (typeof OneTrust !== "undefined" && typeof OneTrust.ToggleInfoDisplay === "function") {
        OneTrust.ToggleInfoDisplay();
    } else {
        console.warn('OneTrust is not loaded yet.');
    }
    return false;
}

// Pass consent selections from OneTrust to Shopify
function listenForConsentUpdates() {
  window.addEventListener("OneTrustGroupsUpdated", otEvent => {
    var shopifyConsentGroups = {
      "analytics": otEvent.detail.includes('C0002'),
      "preferences": otEvent.detail.includes('C0003'),
      "marketing": otEvent.detail.includes('C0004'),
      "sale_of_data": otEvent.detail.includes('C0004')
    };
    window.Shopify.customerPrivacy.setTrackingConsent(shopifyConsentGroups, () => {
      var updatedConsent = window.Shopify.customerPrivacy.currentVisitorConsent(); 
      window.console.log('~~~~updated Shopify Consent', updatedConsent);
    });    
  });
}

/* PLP sticky filter bar */
function initPLPStickyNav() {
  var collectionNavBar = $('.navigation--root[data-sticky="true"]');
  let plpNavTop = collectionNavBar.offset().top;
  
  function plpstickynavbar() {
    var annHeight = document.documentElement.style.getPropertyValue('--announcement-height').replace('px', '');
    var hdrHeight = document.documentElement.style.getPropertyValue('--header-height').replace('px', '');
    var scrollTrigger = (window.scrollY + parseInt(annHeight) + parseInt(hdrHeight));
    
    var collectionNavBar = $('.navigation--root[data-sticky="true"]');
    var persistentBanner = $('.persistent-banner');

    if (scrollTrigger >= plpNavTop) {
      collectionNavBar.addClass('is-stuck');
      persistentBanner.addClass('hide-persistent');
    } else {
      collectionNavBar.removeClass('is-stuck');
      persistentBanner.removeClass('hide-persistent');
    }
  }
  plpstickynavbar();
  window.addEventListener('scroll', plpstickynavbar);
}
/* END: PLP sticky filter bar */

function accessibilityFixes() {
  $('body').on('keydown', 'a, [role="button"]', function(e) {
      if (e.key === ' ') {
        e.preventDefault(); // Prevent default spacebar behavior (scrolling)
        $(this).trigger('click'); // Trigger the button's click event
      }
  });
}

/* set up custom ElevarDataLayer events */
function bindCustomElevarEvents() {

  /** 
   * Optimove in GTM needs a "cart_empty" event
   * sent only when the cart goes from 1 or more to Zero
  */
  window.on('theme:cart:quantityUpdated', ({ detail: data }) => {
    if (data.items_removed && data.items_removed.length) {
      if (data.item_count == 0) {
        window.ElevarDataLayer.push({ event: "cart_empty" });
      }
    }
  });
}

/** quickshop **/

(function () {
  if (window.__productTileMobileQuickshopInit) return;
  window.__productTileMobileQuickshopInit = true;

  const CARD_SELECTOR = 'product-tile-root[data-product-item]';
  const SWATCH_SELECTOR = '.radios--swatch-button';
  const SIZE_BTN_SELECTOR = '.product-card-size-hover__btn';
  const MOBILE_TRIGGER_SELECTOR = '.product-card-mobile-qs-trigger';
  const MOBILE_QS_CLOSE_SELECTOR = '[data-mobile-qs-close]';
  const GLOBAL_QS_SELECTOR = '#global-mobile-quickshop';

  const groupCache = new Map();

  function getCard(el) {
    return el.closest(CARD_SELECTOR);
  }

  function getGlobalQuickshop() {
    return document.querySelector(GLOBAL_QS_SELECTOR);
  }

  function openMobileQuickshop() {
    const qs = getGlobalQuickshop();
    if (!qs) return;

    qs.classList.add('is-open');
    qs.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mobile-qs-open');
    document.body.classList.add('mobile-qs-open');
  }

  function closeMobileQuickshop() {
    const qs = getGlobalQuickshop();
    if (!qs) return;

    qs.classList.remove('is-open');
    qs.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mobile-qs-open');
    document.body.classList.remove('mobile-qs-open');
  }

  async function fetchProduct(handle) {
    const response = await fetch(`/products/${handle}.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(`Failed to fetch product: ${handle}`);
    return response.json();
  }

  async function getProduct(handle, masterSku) {
    let group = groupCache.get(masterSku);
    if (!group) {
      group = new Map();
      groupCache.set(masterSku, group);
    }
    if (!group.has(handle)) {
      const product = await fetchProduct(handle);
      group.set(handle, product);
    }
    return group.get(handle);
  }

  function getSizeOptionIndex(product) {
    if (!product?.options?.length) return -1;
    return product.options.findIndex(
      (name) => String(name).toLowerCase() === 'size'
    );
  }

  function getSizeLabel(variant, sizeIndex) {
    if (sizeIndex === 0) return variant.option1 || variant.title;
    if (sizeIndex === 1) return variant.option2 || variant.title;
    if (sizeIndex === 2) return variant.option3 || variant.title;
    const parts = String(variant.title || '').split(' / ');
    return parts[parts.length - 1] || variant.title;
  }

  function getCardPriceHTML(card) {
    const priceEl =
      card.querySelector('.js-tile-price') ||
      card.querySelector('.product--price-container');

    return priceEl ? priceEl.innerHTML : '';
  }

  function getCardImageData(card) {
    const img =
      card.querySelector('.product--image img') ||
      card.querySelector('.product--image-wrapper img');

    if (!img) {
      return { src: '', alt: '' };
    }

    return {
      src: img.currentSrc || img.src || '',
      alt: img.alt || ''
    };
  }

  function getCardTitle(card) {
    const el = card.querySelector('.product--title');
    return el ? el.textContent.trim() : '';
  }

  function getCardLink(card) {
    const link = card.querySelector('.product-tile--link[href]');
    return link ? link.href : '#';
  }

  function updateCardSizeButtons(card, product) {
    const sizeIndex = getSizeOptionIndex(product);
    const variants = product.variants || [];

    ['.product-card-size-hover__inner'].forEach((sel) => {
      const wrap = card.querySelector(sel);
      if (!wrap) return;

      wrap.innerHTML = '';

      variants.forEach((variant) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product-card-size-hover__btn';
        btn.dataset.variantId = String(variant.id);
        btn.dataset.productHandle = product.handle;
        btn.textContent = getSizeLabel(variant, sizeIndex);
        btn.disabled = !variant.available;
        btn.classList.toggle('is-disabled', !variant.available);
        wrap.appendChild(btn);
      });
    });
  }

  function updateGlobalQuickshopImage(product, fallbackCard) {
    const qs = getGlobalQuickshop();
    const img = qs?.querySelector('.mini-product-image img');
    if (!qs || !img) return;

    let src = product?.featured_image || product?.images?.[0] || '';
    let alt = product?.title || '';

    if (!src && fallbackCard) {
      const fallback = getCardImageData(fallbackCard);
      src = fallback.src;
      alt = fallback.alt;
    }

    if (!src) return;

    img.src = src;
    img.alt = alt || img.alt || '';
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
  }

  function updateGlobalQuickshopTitle(product, fallbackCard) {
    const qs = getGlobalQuickshop();
    const title = qs?.querySelector('.mini-product-title');
    if (!title) return;

    const text = product?.title || (fallbackCard ? getCardTitle(fallbackCard) : '');
    title.textContent = text || '';
  }

  function updateGlobalQuickshopLink(product, fallbackCard) {
    const qs = getGlobalQuickshop();
    const link = qs?.querySelector('.mini-product-url');
    if (!link) return;

    if (product?.url) {
      link.href = product.url;
      return;
    }

    if (fallbackCard) {
      link.href = getCardLink(fallbackCard);
    }
  }

  function updateGlobalQuickshopPrice(card) {
    const qs = getGlobalQuickshop();
    const priceWrap = qs?.querySelector('.js-quickshop-price');
    if (!priceWrap || !card) return;

    priceWrap.innerHTML = getCardPriceHTML(card);
  }

  function updateGlobalQuickshopSizes(product) {
    const qs = getGlobalQuickshop();
    const wrap = qs?.querySelector('.variant-options');
    if (!wrap) return;

    const sizeIndex = getSizeOptionIndex(product);
    const variants = product.variants || [];

    wrap.innerHTML = '';

    variants.forEach((variant) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-card-size-hover__btn single-variant-option';
      btn.dataset.variantId = String(variant.id);
      btn.dataset.productHandle = product.handle;
      btn.textContent = getSizeLabel(variant, sizeIndex);
      btn.disabled = !variant.available;
      btn.classList.toggle('is-disabled', !variant.available);
      wrap.appendChild(btn);
    });
  }

  async function populateGlobalQuickshopFromCard(card) {
    const qs = getGlobalQuickshop();
    if (!qs || !card) return;

    const handle = card.dataset.productHandle;
    const masterSku = card.dataset.masterSku;

    qs.__sourceCard = card;
    qs.dataset.productHandle = handle || '';
    qs.dataset.masterSku = masterSku || '';

    updateGlobalQuickshopPrice(card);
    updateGlobalQuickshopTitle(null, card);
    updateGlobalQuickshopLink(null, card);
    updateGlobalQuickshopImage(null, card);

    if (!handle || !masterSku) return;

    try {
      const product = await getProduct(handle, masterSku);
      updateGlobalQuickshopImage(product, card);
      updateGlobalQuickshopTitle(product, card);
      updateGlobalQuickshopLink(product, card);
      updateGlobalQuickshopSizes(product);
      updateCardSizeButtons(card, product);
    } catch (e) {
      console.error('Failed to populate global quickshop:', e);
    }
  }

  async function onSwatchClick(swatch) {
    const card = getCard(swatch);
    if (!card) return;

    const handle = swatch.dataset.productHandle;
    const masterSku = card.dataset.masterSku;
    if (!handle || !masterSku) return;

    try {
      const product = await getProduct(handle, masterSku);

      card.dataset.productHandle = product.handle || handle;
      updateCardSizeButtons(card, product);

      const qs = getGlobalQuickshop();
      if (qs?.__sourceCard === card) {
        qs.dataset.productHandle = product.handle || handle;
        updateGlobalQuickshopImage(product, card);
        updateGlobalQuickshopTitle(product, card);
        updateGlobalQuickshopLink(product, card);
        updateGlobalQuickshopSizes(product);

        requestAnimationFrame(() => updateGlobalQuickshopPrice(card));
        setTimeout(() => updateGlobalQuickshopPrice(card), 200);
      }
    } catch (e) {
      console.error('Failed to update quickshop content:', e);
    }
  }

  async function addVariantToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;
    if (btn.dataset.loading === 'true') return;

    btn.dataset.loading = 'true';

    try {
      await theme.cart.addItem({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      }, variantId);

      closeMobileQuickshop();
      theme.drawer.open('right', 'cart-drawer', btn);
    } catch (error) {
      console.error('Add to cart failed:', error);
    } finally {
      delete btn.dataset.loading;
    }
  }

 document.addEventListener('click', async function (e) {
  const trigger = e.target.closest(MOBILE_TRIGGER_SELECTOR);
  if (trigger) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const card = getCard(trigger);
    if (!card) return;

    await populateGlobalQuickshopFromCard(card);
    openMobileQuickshop();
    return;
  }

  const close = e.target.closest(MOBILE_QS_CLOSE_SELECTOR);
  if (close) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    closeMobileQuickshop();
    return;
  }

  const sizeBtn = e.target.closest(SIZE_BTN_SELECTOR);
  if (sizeBtn) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    addVariantToCart(sizeBtn);
    return;
  }

  const swatch = e.target.closest(SWATCH_SELECTOR);
  if (swatch) {
    onSwatchClick(swatch);
  }
}, true);
})(); 

/** hide klaviyo pop up when quickshop is open **/

function hideKlaviyoWhenQuickshopOpen() {
  const quickshop = document.getElementById('global-mobile-quickshop');
  if (!quickshop) return;

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function isQuickshopOpen() {
    return (
      isMobile() &&
      (
        quickshop.classList.contains('is-open') ||
        quickshop.getAttribute('aria-hidden') === 'false'
      )
    );
  }

  function updateState() {
    if (isQuickshopOpen()) {
      document.documentElement.setAttribute('data-quickshop-open', 'true');
    } else {
      document.documentElement.removeAttribute('data-quickshop-open');
    }
  }

  new MutationObserver(updateState).observe(quickshop, {
    attributes: true,
    attributeFilter: ['class', 'aria-hidden'],
  });

  window.addEventListener('resize', updateState);
  updateState();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hideKlaviyoWhenQuickshopOpen);
} else {
  hideKlaviyoWhenQuickshopOpen();
}

/* 
  ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
  END: area to define custom functions
  =====================================================
*/

/* 
  jQueryIsReady is just like like $(document).ready() - put your jQuery code here to avoid timing errors
*/
var jQueryIsReady = function() {
  /* 
    START: add any jQuery code or call functions that DEPEND on jQuery within this block
    (don't define functions here, just call them from here)
    v v v v v v v v v v v v v v v v v v v v v v v v v v v
  */
  
  accessibilityFixes();

  if ( $('.navigation--root[data-sticky="true"]').length ) {
     initPLPStickyNav();
  }
  
  /* 
    ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
    END: code that DEPENDS on jQuery goes in the area above
  */
} 
// end jQueryIsReady
// ========================================================================


/* 
  dkCustomInit is a function that runs immediately on page load, 
  but may finish before jQuery is fully loaded
*/
function dkCustomInit() {
  var checkJquery = function(){
    if (typeof jQuery === "undefined"){
        return false;
    } else {
        clearTimeout(jqInterval);
        jQueryIsReady();
    }
  }
  var jqInterval = setInterval(checkJquery,1000);

  /* 
    START: call any functions that DON'T depend on jQuery within this block
    (don't define functions here, just call them from here)
    v v v v v v v v v v v v v v v v v v v v v v v v v v v
  */

  
  // Pass consent selections from OneTrust to Shopify
  listenForConsentUpdates();

  bindCookiePrefsClick();  
  bindCustomElevarEvents();
 
  
  /* 
    ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
    END: functions that DON'T depend on jQuery
    =====================================================
  */ 
}
// end dkCustomInit
// ========================================================================


/* LEAVE THIS AT THE BOTTOM OF THE FILE AND DO NOT EDIT */
if (/complete|interactive|loaded/.test(document.readyState)) {
    dkCustomInit();
} else {
    document.addEventListener('DOMContentLoaded', dkCustomInit);
}


function getFocusableElements(container) {
  return [...container.querySelectorAll(`
    a[href],
    button:not([disabled]),
    textarea:not([disabled]),
    input:not([disabled]),
    select:not([disabled]),
    [tabindex]:not([tabindex="-1"])
  `)].filter((el) => {
    return !el.hasAttribute('hidden') && el.offsetParent !== null;
  });
}

function openModal(modal, trigger = null) {
  if (!modal) return;

  modal.setAttribute('aria-hidden', 'false');
  modal._trigger = trigger || document.activeElement;

  const transitionItem = modal.querySelector('[data-transition-item]');
  if (transitionItem) {
    transitionItem.setAttribute('data-transition-active', 'true');
  }

  const focusable = getFocusableElements(modal);
  if (focusable.length) {
    focusable[0].focus();
  }
}

function closeModal(modal) {
  if (!modal) return;

  modal.setAttribute('aria-hidden', 'true');

  const transitionItem = modal.querySelector('[data-transition-item]');
  if (transitionItem) {
    transitionItem.setAttribute('data-transition-active', 'false');
  }

  if (modal._trigger) {
    modal._trigger.focus();
  }
}

document.addEventListener('click', (event) => {
  const openButton = event.target.closest('.product-size-chart--link');
  if (openButton) {
    event.preventDefault();
    openModal(
      document.querySelector('.modal--root[data-id="size-chart"]'),
      openButton
    );
    return;
  }

  const closeButton = event.target.closest('.modal--close');
  if (closeButton) {
    closeModal(closeButton.closest('.modal--root'));
  }
});

document.addEventListener('keydown', (event) => {
  const modal = document.querySelector('.modal--root[aria-hidden="false"]');
  if (!modal) return;

  if (event.key === 'Escape') {
    closeModal(modal);
    return;
  }

  if (event.key !== 'Tab') return;

  const focusable = getFocusableElements(modal);
  if (!focusable.length) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
});